import React, { useState, useEffect } from 'react';

function CarouselPlaceholder() {
  const images = ['bambo1.jpg', 'bambo2.jpg', 'bambo3.jpg'];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex]); // Agregamos la línea de arriba para que Vercel no se queje de 'nextSlide'

  const nextSlide = () => setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  const prevSlide = () => setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));

  return (
    <div style={{ width: '100%', height: '85vh', position: 'relative', overflow: 'hidden', backgroundColor: '#000' }}>
      
      {/* Overlay de texto estilo Wix */}
      <div style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10,
        backgroundColor: 'rgba(0,0,0,0.3)',
        pointerEvents: 'none'
      }}>
        <h1 style={{ color: '#fff', fontSize: '120px', fontWeight: '900', margin: 0, letterSpacing: '-5px', lineHeight: '0.9' }}>
          BAMBO <br/> <span style={{ color: '#FFD700' }}>EVENTOS</span>
        </h1>
        <p style={{ color: '#fff', fontSize: '18px', letterSpacing: '10px', marginTop: '20px' }}>LOS MEJORES EVENTOS</p>
      </div>

      <img 
        src={`/img/${images[currentIndex]}`} 
        alt="Bambú"
        style={{ width: '100%', height: '100%', objectFit: 'cover', transition: '0.8s ease-in-out' }}
      />

      <button onClick={prevSlide} style={{ ...navButtonStyle, left: '30px' }}>❮</button>
      <button onClick={nextSlide} style={{ ...navButtonStyle, right: '30px' }}>❯</button>
    </div>
  );
}

const navButtonStyle = {
  position: 'absolute', top: '50%', transform: 'translateY(-50%)',
  backgroundColor: 'rgba(0,0,0,0.2)', color: 'white', border: 'none',
  padding: '20px', cursor: 'pointer', fontSize: '24px', zIndex: 20
};

export default CarouselPlaceholder;